// Human-friendly level labels. Levels 1/2/3 map to skill tiers; A/Y are special tracks.
const MAP = {
  1: "Beginner",
  2: "Intermediate",
  3: "Advanced",
  A: "Advocacy",
  Y: "Youth",
};

export function levelLabel(level) {
  if (level === null || level === undefined || level === "") return "";
  const key = typeof level === "string" && !/^\d+$/.test(level) ? level.toUpperCase() : Number(level);
  return MAP[key] || `Level ${level}`;
}

// [value, label] pairs for the public Games filter.
export const LEVEL_FILTERS = [
  ["", "All levels"],
  ["1", "Beginner"],
  ["2", "Intermediate"],
  ["3", "Advanced"],
  ["A", "Advocacy"],
  ["Y", "Youth"],
];
